import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios, { renderDoc } from '../Axiosinstance';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Header from '../components/Header';
import FinHeader from '../Finance/Fheader';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { BsPencilFill, BsTrashFill } from 'react-icons/bs';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import * as XLSX from 'xlsx';
import { Typography, Grid, Divider, Box } from '@mui/material'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { toast, ToastContainer } from 'react-toastify';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
import Newstudent from './Newstudent'
import Loader from '../Loader';
import Modal from 'react-bootstrap/Modal';
import { InputLabel, FormControl } from '@material-ui/core';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Form } from 'react-bootstrap';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import OfferLetter from '../components/OfferLetter';
import ContractLetter from '../components/ContractLetter'
import pdfTemplate from '../All/registration-receipt.pdf';
import Instalment from '../pdf/instalment-receipt.pdf'
import PhoneInput from 'react-phone-input-2'
import Stack from '@mui/material/Stack';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { saveAs } from 'file-saver';
import ARIALItalicLight from '../fonts/ARIALI1.TTF'
import calibriFontBold from '../fonts/CalibriBold.ttf'
import calibriFont from '../fonts/calibri.ttf'
import fontkit from '@pdf-lib/fontkit';
import DownloadIcon from '@mui/icons-material/Download';
import ArialitalicBold2 from '../fonts/ArialMdmItl.ttf'
import ArialItalicBold from '../fonts/ArialCEBoldItalic.ttf'
import calibriFontItalic from '../fonts/calibri-italic.ttf';
import App from '../components/ContractLetter';
import AdmissionOffer from '../components/OfferLetter';
import registration from '../All/registration'
import Editstudent from '../components/EditStudent'
import ApplicationForm from '../components/ApplicationForm';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { buttonBackgroundColor,timestamp } from '../common'

const columns = [
  { id: 'S.NO', label: 'S.NO', minWidth: 50 },
  { id: 'fullname', label: 'Name', minWidth: 120 },
  { id: 'email', label: 'Email', minWidth: 150 }, // reduced width
  { id: 'phone', label: 'Phone', minWidth: 120 },
  { id: 'gender', label: 'Gender', minWidth: 100 },
  { id: 'actions', label: 'Actions', minWidth: 120 },
  { id: 'Status Update', label: 'Status Update', minWidth: 140 },
  { id: 'view', label: 'View', minWidth: 100 },
];



const Screen = () => {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]); // Define filteredStudents
  // const [currentPage, setCurrentPage] = useState(1);
  // const [studentsPerPage, setStudentsPerPage] = useState(100);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterGender, setFilterGender] = useState('');
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editedStudent, setEditedStudent] = useState({});
  // const [pageSize, setPageSize] = useState(10);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const CLOUDINARY_URL = baseURL;
  const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [status, setStatus] = useState('');
  const [remark, setRemark] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [dataProp, setDataProp] = useState([]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));


  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentDetails, setStudentDetails] = useState(null);
  const [studentInfo, setStudentInfo] = useState(null);

  const [scheduleData, setScheduleData] = useState([]);
  const modalContentRef = useRef(null);
  const [data, setData] = useState(null);

  const [dataForprop, setDataForprop] = useState(null);

  const childRef = useRef(null);
  const admissionOfferRef = useRef(null);
  const applicationFormRef = useRef(null);

  const [showModal1, setShowModal1] = useState(false);
  const [letterType, setLetterType] = useState('');
  const [sessionId, setSessionId] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState('');


  const [pdfUrl, setPdfUrl] = useState(null);
  const [open, setOpen] = useState(false);
  const [pdfFileName, setPdfFileName] = useState('');

  const handleClosePdfDialog = () => {
    setOpen(false);
    setPdfUrl(null);
  };
  const navigate = useNavigate();


  const handleDownload = () => {
    if (!pdfUrl || !pdfFileName) return;

    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = pdfFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };


  const handleOpenStatusModal = (student) => {
    // console.log("Selected student:", student); // Check the student object received
    fetchStudentById(student.id); // Fetch the latest data for the student
    setEditedStudent(student);
    setShowStatusModal(true);
  };

  // Function to handle closing of the status modal
  const handleCloseStatusModal = () => {
    setShowStatusModal(false);
  };

  const paymentType = studentInfo?.paymentType === "online" ? "(omt)" : "";

  const handleStatusUpdate = async () => {
    if (status !== 'Withdraw' && status !== 'Deferred' && status !== 'Pending') {
      toast.error('Please select a valid option.');
      return; // Exit the function if the status is invalid
    }
    if (remark === null || remark.trim() === '') {
      toast.error('Remarks cannot be empty.');
      return; // Exit the function if remarks are empty
    }
    try {
      console.log('Selected status:', status);
      // console.log('Updating status and remarks for student:', editedStudent.id);

      const response1 = await axios.put(`/registrationadvances/update-status`, {
        status: status,
        registrationId: editedStudent.registrationAdvanceId,
        remarks: remark
      });

      if (response1.status === 200) {
        toast.success('Status and remarks updated successfully');
        // console.log('Status and remarks updated successfully, response:', response1.data);

        // Fetch the updated student list
        await fetchStudents();

        handleCloseStatusModal(); // Close the modal after update
      } else {
        console.error('Failed to update status and remarks, response:', response1);
        toast.error('Failed to update status and remarks');
      }
    } catch (error) {
      console.error('Error updating status and remarks:', error);
      toast.error('Error updating status and remarks');
    }
  };





  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      setLoading(true); // Set loading to true when starting to fetch data
      const response = await axios.get('/registrationadvances/activeStudentDetailss');
      // setStudents(response.data.reverse());
      setStudents(response.data);
      setFilteredStudents(response.data);
      setLoading(false); // Set loading to false when data is loaded
      // console.log(response.data)
    } catch (error) {
      console.error('Error fetching students:', error);
      setLoading(false); // Set loading to false in case of an error
    }
  };


  const fetchStudentById = async (studentId) => {
    try {
      const response = await axios.get(`/student/${studentId}`);
      const student = response.data;
      setStatus(student.status);
      setRemark(student.remarks);
      // setEditedStudent(student); // Ensure editedStudent is set correctly
      console.log(student);
    } catch (error) {
      console.error('Error fetching student data:', error);
      toast.error('Error fetching student data');
    }
  };

  // const formatDate = (dateString) => {
  //   if (!dateString) return '-';
  //   const date = new Date(dateString);
  //   return format(date, "dd mmmm, yyyy 'at' HH:mm:ss");
  // };

  function formatDateEnd(dateString) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const filtered = students.filter((student) => {
      if (filterGender && student.gender !== null && student.gender !== undefined) {
        return student.gender.toLowerCase() === filterGender.toLowerCase();
      }
      return true;
    });

    const searchFiltered = filtered.filter((student) =>
      student.fullname.toLowerCase().includes(searchQuery.toLowerCase())
    );


    setFilteredStudents(searchFiltered);
    // }, [searchQuery, filterGender, students, currentPage, pageSize, filterType]);
  }, [searchQuery, filterGender, students, filterType]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    // setCurrentPage(1); // Reset to the first page when searching
  };

  const handleFilterGender = (gender) => {
    setFilterGender(gender);
    // setCurrentPage(1); // Reset to the first page when applying filters
  };


  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingStudentId, setDeletingStudentId] = useState(null);

  const handleViewStudent = async (student) => {
    try {
      // First API call
      const response1 = await axios.get(`/registrationadvances/${student.registrationAdvanceId}`);
      const { scheduleDate, ...studentData1 } = response1.data;
      setDataProp(response1.data)
      // console.log("response1"+response1.data)

      // Second API call
      const response2 = await axios.get(`/registrationadvances/info/${student.registrationAdvanceId}`);
      const { courseFeeDetails, installmentsPaid, amount1, type } = response2.data;
      // alert(JSON.stringify(response2.data, null, 2));
      setStudentInfo(response2.data);
      console.log("for dd", response2.data)
      // Set state with data from both API calls
      setStudentDetails(studentData1);
      //  console.log("hello", scheduleDate)
      setScheduleData(scheduleDate);
      setData({ courseFeeDetails, installmentsPaid, amount1, type });
      setDataForprop(response1.data);
      // Show modal
      setShowModal(true);

    } catch (error) {
      console.error('Error fetching student details:', error);
    }
  };

  const numberToWords = (number) => {
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    const teens = ['', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    const suffixes = ['', 'thousand'];


    const numToWords = (num) => {
      let words = '';
      if (num >= 1000) {
        words += numToWords(Math.floor(num / 1000)) + ' thousand ';
        num %= 1000;
      }
      if (num >= 100) {
        words += ones[Math.floor(num / 100)] + ' hundred ';
        num %= 100;
      }
      if (num >= 20) {
        words += tens[Math.floor(num / 10)] + ' ';
        num %= 10;
      }
      if (num > 0) {
        if (num >= 11 && num <= 19) {
          words += teens[num - 10] + ' ';
        } else {
          words += ones[num] + ' ';
        }
      }
      return words.trim();
    };

    if (number === 0) return 'zero';
    return numToWords(number);
  };
  const toUpperCaseString = (str) => {
    return str?.toUpperCase();
  };
  const toUpperCaseString1 = (str) => {
    // Remove trailing numbers within parentheses
    return str.replace(/\(\d+\)$/, '').toUpperCase();
  };

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
      "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
    ];
    return monthNames[monthNumber];
  };

  // Function to format the date
  const toUpperCaseString11 = (dateString) => {
    const date = new Date(dateString);
    const month = getMonthName(date.getMonth());
    const year = date.getFullYear();
    return `${month} ${year}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };


  // Function to get the last two digits of the year from a date string
  const getYear = (dateString) => {
    const date = new Date(dateString);
    return date.getFullYear().toString().slice(-2); // Get last two digits of the year
  };

  const registrationFee = studentInfo?.installmentsPaid?.length > 0 ? studentInfo.installmentsPaid[studentInfo.installmentsPaid.length - 1].amount : 0;
  const totalAmount = registrationFee / 1.09;
  const gst = registrationFee - totalAmount;
  const sumOfDollars = numberToWords(registrationFee);

  const getOrdinalSuffix = (num) => {
    const j = num % 10,
      k = num % 100;
    let suffix = "th";
    if (j === 1 && k !== 11) {
      suffix = "st";
    } else if (j === 2 && k !== 12) {
      suffix = "nd";
    } else if (j === 3 && k !== 13) {
      suffix = "rd";
    }

    // Return the number with the appropriate suffix
    return `${suffix}`;
  };



  const handlePdfEdit = async (installment, index) => {

    const pdfBytes = await fetch(pdfTemplate).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    pdfDoc.registerFontkit(fontkit);


    // Example: Assuming formValues contains user input
    // const { invoiceNo, totalFee, installmentCount, feeType } = formValues;

    // Load the font
    const calibriFontBytes = await fetch(calibriFont).then((res) => res.arrayBuffer());
    const calibriFontEmbed = await pdfDoc.embedFont(calibriFontBytes);

    const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) => res.arrayBuffer());
    const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

    const calibriFontItalicBytes = await fetch(calibriFontItalic).then((res) => res.arrayBuffer());
    const calibriFontItalicEmbed = await pdfDoc.embedFont(calibriFontItalicBytes);

    // Example: Draw text using the embedded font and user input values
    // firstPage.drawText(`Installment Count: ${installment.installmentCount}`, { x: 50, y: 600, size: 12, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(`TAX INVOICE`, { x: 420, y: 775, size: 19, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(`GST No. 201322342Z`, { x: 420, y: 760, size: 12, font: calibriFontEmbed, color: rgb(0, 0, 0) });


    firstPage.drawText(
      `  ${studentInfo.late
        ? (index === 0
          ? formatDate(studentInfo.scheduleDate)
          : formatDate(installment.sessionDate)
        )
        : formatDate(installment.sessionDate)
      }`,
      { x: 380, y: 666.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) }
    );

    firstPage.drawText(` $${installment.amount}`, { x: 478, y: 565, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` $${installment.amount}`, { x: 478, y: 493, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

    firstPage.drawText(` $${((installment.amount) - (installment.amount / 1.09)).toFixed(2)})`, { x: 152, y: 545, size: 9, font: calibriFontItalicEmbed, color: rgb(0, 0, 0) });
    // firstPage.drawText(` ${installment.amount} (OMT)`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` ${installment.amount}`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    if (installment.paymentMode === 'online') {
      firstPage.drawText(` ${installment.amount} (OMT)`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    }else {
      firstPage.drawText(` ${installment.amount}`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    }

    firstPage.drawText(` ${toUpperCaseString1(numberToWords(installment.amount))} DOLLARS ONLY`, { x: 131.5, y: 495, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` ${installment.registrationFeeRemaining}`, { x: 109, y: 522, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });


    firstPage.drawText(`OFFICIAL INVOICE NO:`, { x: 360, y: 677, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

    if (studentInfo) {
      const invoiceString = `JA${getYear(installment.sessionDate)}-${String(installment.sequenceNumber).padStart(4, '0')}-${studentInfo.nric}-R`;
      // const x = 410;
      const x = 445;
      const y = 677;
      const size = 9;
      const font = calibriFontBoldEmbed;
      firstPage.drawText(invoiceString, { x, y, size, font, color: rgb(0, 0, 0) });

      // Measure the width of the text
      const textWidth = font.widthOfTextAtSize(invoiceString, size);
      // Draw the underline
      firstPage.drawLine({
        start: { x, y: y - 1 },
        end: { x: x + textWidth, y: y - 1 },
        thickness: 0.5,
        color: rgb(0, 0, 0),
      });
      firstPage.drawText(` ${toUpperCaseString1(studentInfo.name)}`, { x: 184, y: 641.6, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString1(studentInfo.nric)}`, { x: 184, y: 629.3, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString1(studentInfo.course)}`, { x: 184, y: 617, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString11(studentInfo.startModuleDate)}`, { x: 184, y: 605, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText('This is computer generated document no signature required.', { x: 69, y: 450, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

      // firstPage.drawText(` ${toUpperCaseString1(studentInfo.approver)}`, { x: 100.5, y: 479, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });

      // if (installment.discountAmount !== 0 && installment.discountAmount !== null) {
      //   firstPage.drawText(` Discount:$${installment.discountAmount}`, { x: 70, y: 533, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
      // }


      if (studentInfo.amount1 != 0 && index === 0) {
        // If studentinfo.amount1 is not equal to 0, display the discount
        firstPage.drawText(` Discount:$${studentInfo.amount1}`, {
          x: 70,
          y: 533,
          size: 9,
          font: calibriFontEmbed,
          color: rgb(0, 0, 0)
        });
      } else if (installment.discountAmount !== 0 && installment.discountAmount !== null) {
        // If installment.discountAmount is not 0 and not null, display the discount
        firstPage.drawText(` Discount:$${installment.discountAmount}`, {
          x: 70,
          y: 533,
          size: 9,
          font: calibriFontEmbed,
          color: rgb(0, 0, 0)
        });
      }

      // Add more student details as needed
    }


    // Save the PDF document
    // const pdfBytesEdited = await pdfDoc.save();
    // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
    // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-REGISTRATION-RECEIPT.pdf`);

    const pdfBytesModified = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    // window.open(pdfUrl, '_blank');
    // saveAs(pdfBlob, `${toUpperCaseString(studentInfo.name)}-REG-${installment.sequenceNumber}.pdf`);
    const studentName = studentInfo.name.replace(/\s+/g, '_');
    const fileName = `${studentName}_REG_${installment.sequenceNumber}.pdf`;
    setPdfUrl(pdfUrl);
    setPdfFileName(fileName);
    setOpen(true); // Open dialog
  };

  const handlePdfEdit1 = async (feeDetail, type) => {

    const pdfBytes = await fetch(Instalment).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    pdfDoc.registerFontkit(fontkit);


    // Example: Assuming formValues contains user input
    // const { invoiceNo, totalFee, installmentCount, feeType } = formValues;

    // Load the font
    const calibriFontBytes = await fetch(calibriFont).then((res) => res.arrayBuffer());
    const calibriFontEmbed = await pdfDoc.embedFont(calibriFontBytes);


    const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) => res.arrayBuffer());
    const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

    const calibriFontItalicBytes = await fetch(ArialitalicBold2).then((res) => res.arrayBuffer());
    const calibriFontItalicEmbed = await pdfDoc.embedFont(calibriFontItalicBytes);

    const calibriFontItalicBoldBytes = await fetch(ArialItalicBold).then((res) => res.arrayBuffer());
    const calibriFontItalicBoldEmbed = await pdfDoc.embedFont(calibriFontItalicBoldBytes);

    const ArialItalicLight = await fetch(ARIALItalicLight).then((res) => res.arrayBuffer());
    const ArialItalicLightEmbed = await pdfDoc.embedFont(ArialItalicLight);

    // Example: Draw text using the embedded font and user input values
    firstPage.drawText(`  ${formatDate(feeDetail.sessionDate)}`, { x: 384, y: 629.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` $${feeDetail.amount}`, { x: 475.5, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` ${feeDetail.amount}`, { x: 483.5, y: 474, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

    firstPage.drawText(` $${((feeDetail.amount) - (feeDetail.amount / 1.09)).toFixed(2)})`, { x: 184, y: 530, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    const installmentText = feeDetail.installmentCounts
      .map((count) => `${count}${getOrdinalSuffix(count)}`)
      .join(","); // Join them with a space
    console.log("feeDetail.installmentCounts", installmentText);
    // firstPage.drawText(` ${feeDetail.installmentCount} ${' '} Instalment $${feeDetail.amount} (OMT)`, { x: 75, y: 540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` ${installmentText} ${' '} Installment $${feeDetail.amount} `, { x: 75, y: 540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    if (feeDetail.paymentMode === 'online') {
      firstPage.drawText(` ${installmentText} ${' '} Installment $${feeDetail.amount} (OMT)`, { x: 75, y:  540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    }else{
      firstPage.drawText(` ${installmentText} ${' '} Installment $${feeDetail.amount} `, { x: 75, y: 540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    }


    // firstPage.drawText(` ${installment.amount}`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
    // firstPage.drawText(` ${getOrdinalSuffix(feeDetail.installmentCounts[0])}`, { x: 81, y: 545, size: 6, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` ${toUpperCaseString1(numberToWords(feeDetail.amount))} DOLLARS ONLY`, { x: 141.5, y: 475.3, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
    const currentInstallments = feeDetail.installmentCounts || [];
    let installmentDisplayText = "";

    // if (feeDetail.remainingBalance === 0) {
    //   // If there is no remaining balance, show the next installment count only
    //   const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
    //   installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
    // } else {
    //   // If there is a remaining balance, include both current balance and next installment
    //   const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
    //   installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
    // }
    if (type === "diploma") {
      if (feeDetail.remainingBalance === 0) {
        // If there is no remaining balance, show the next installment count only
        const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
        if (lastInstallment >= 12) {
          installmentDisplayText = "-";
        }
        else {
          installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
        }
      } else {
        // If there is a remaining balance, include both current balance and next installment
        const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
        if (lastInstallment >= 12) {
          installmentDisplayText = "-";
        }
        else {
          installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
        }
      }
    }
    else if (type === "advance_diploma") {
      if (feeDetail.remainingBalance === 0) {
        // If there is no remaining balance, show the next installment count only
        const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
        if (lastInstallment >= 6) {
          installmentDisplayText = "-";
        }
        else {
          installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
        }
      } else {
        // If there is a remaining balance, include both current balance and next installment
        const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
        if (lastInstallment > 6) {
          installmentDisplayText = "-";
        }
        else if (lastInstallment === 6) {
          installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance`;
        }
        else {
          installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
        }
      }

    }

    firstPage.drawText(` ${installmentDisplayText}${'  '} `, { x: 190, y: 496.5, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    // firstPage.drawText(` ${getOrdinalSuffix(feeDetail.installmentCount + 1)} `, { x: 196, y: 500.5, size: 6, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
    firstPage.drawText(` $${feeDetail.courseFeeRemaining}`, { x: 156, y: 507.5, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });

    if (studentInfo) {


      const paid_date = getYear(feeDetail.sessionDate);
      const formatteddate = paid_date % 100;
      const sequenceNumber = String(feeDetail.sequenceNumber).padStart(4, '0');
      const invoiceString = `JAO/CF-${formatteddate}-${sequenceNumber}`;
      const x = 455;
      const y = 644.3;
      const size = 9;
      const font = calibriFontBoldEmbed;
      firstPage.drawText(toUpperCaseString1(invoiceString), { x, y, size, font, color: rgb(0, 0, 0) });

      // Measure the width of the text
      const textWidth = font.widthOfTextAtSize(invoiceString, size);
      // Draw the underline
      firstPage.drawLine({
        start: { x, y: y - 1 },
        end: { x: x + textWidth, y: y - 1 },
        thickness: 0.5,
        color: rgb(0, 0, 0),
      });

      // firstPage.drawText(invoiceString, { x: 450.5, y: 350, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString1(studentInfo.name)}`, { x: 184, y: 618, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString1(studentInfo.nric)}`, { x: 184, y: 607.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString1(studentInfo.course)}`, { x: 184, y: 597.2, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString11(studentInfo.startModuleDate)}`, { x: 184, y: 586, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText('This is computer generated document no signature required.', { x: 75, y: 420, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      if (feeDetail.discountAmount !== 0) {
        firstPage.drawText(`Discount: ${feeDetail.discountAmount}`, {
          x: 78,
          y: 487,
          size: 9,
          // font: calibriFontBoldEmbed,
          color: rgb(0, 0, 0),
        });
      }

      // firstPage.drawText(` ${toUpperCaseString1(studentInfo.approver)}`, { x: 104, y: 439, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
      // Add more student details as needed
    }

    // Save the PDF document
    // const pdfBytesEdited = await pdfDoc.save();
    // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
    // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-COURSE-RECEIPT.pdf`);
    const pdfBytesModified = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    // window.open(pdfUrl, '_blank');
    // saveAs(pdfBlob, `${toUpperCaseString(studentInfo.name)}-INS-${feeDetail.sequenceNumber}.pdf`);
    const studentName = studentInfo.name.replace(/\s+/g, '_');
    const fileName = `${studentName}_INS_${feeDetail.installmentCounts}.pdf`;
    setPdfUrl(pdfUrl);
    setPdfFileName(fileName);
    setOpen(true); // Open dialog
  };





  const handleContractletter = () => {
    if (childRef.current) {
      childRef.current.handlePdfEdit(); // Call handlePdfEdit function of the child component
    }
  };
  const handleOfferletter = () => {
    if (admissionOfferRef.current) {
      admissionOfferRef.current.handleDownload(); // Call handlePdfEdit function of the child component
    }
  };

  const handleApplicationForm = () => {
    if (applicationFormRef.current) {
      applicationFormRef.current.handleDownload(); // Call handlePdfEdit function of the child component
    }
  };

  const DeleteConfirmationModal = ({ show, handleClose, handleConfirm }) => {
    return (
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure to delete this student?</Modal.Body>
        <Modal.Footer>
          <Button style={{ backgroundColor: 'grey', color: 'white' }} onClick={handleClose}>
            No
          </Button>
          <Button style={{ backgroundColor: 'red', color: 'white', marginLeft: '10px' }} onClick={() => handleConfirm(deletingStudentId)}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const openDetailsModal = (student, isEdit) => {
    setEditedStudent(student);
    setIsReadOnly(!isEdit); // Set read-only mode to true if it's not an edit
    setEditModalOpen(true);
  };


  const handleDelete = (id) => {
    setDeletingStudentId(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = async (id) => {
    try {
      const response = await axios.get(`${id}/remove`);

      if (response.status === 200) {
        // Update state to reflect the deleted student
        const updatedStudents = students.map((student) =>
          student.id === id ? { ...student, status: 'removed' } : student
        );
        console.log('Before update:', students);
        setStudents(updatedStudents);
        console.log('After update:', updatedStudents);
        setFilteredStudents(updatedStudents);
        toast.success('Student deleted successfully');
      } else {
        console.error('Failed to delete student');
        toast.error('Failed to delete student');
      }
    } catch (error) {
      console.error('Error deleting student:', error);
      toast.error('Error deleting student');
    } finally {
      handleCloseDeleteModal();
    }
  };

  const openEditModal = (student) => {
    setEditedStudent(student);
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    try {

      if (
        !editedStudent.fullname ||
        !editedStudent.email ||
        !editedStudent.nric ||
        !editedStudent.phone ||
        !editedStudent.gender ||
        !editedStudent.dob ||
        !editedStudent.password
        // !editedStudent.address ||
        // !editedStudent.postalcode ||
        // !editedStudent.race ||
        // !editedStudent.eduction ||
        // !editedStudent.employmentstatus ||
        // !editedStudent.studentId
        // !editedStudent.salary ||
        // !editedStudent.companyname ||
        // !editedStudent.corporatecompanysponsored ||
        // !editedStudent.designation
      ) {
        toast.error('Please fill in all required fields.');
        return;
      }


      const confirmation = window.confirm('Are you sure you want to update this student?');

      if (!confirmation) {
        return; // Cancel the update if the user clicks "Cancel" in the confirmation alert
      }


      let imageUrl = editedStudent.profileUrl;
      // If a new image is selected, upload it to Cloudinary
      if (selectedFile) {
        const timestamp = Date.now();
        const fileExtension = selectedFile.name.split('.').pop();
        const fileNameWithTimestamp = `${timestamp}.${fileExtension}`;

        const formDataWithImage = new FormData();
        formDataWithImage.append('file', selectedFile, fileNameWithTimestamp);
        formDataWithImage.append('upload_preset', CLOUDINARY_UPLOAD);
        formDataWithImage.append('public_id', `LMS/Student/${fileNameWithTimestamp} +' - '+ ${timestamp}`);

        const imageResponse = await fetch(CLOUDINARY_URL, {
          method: 'POST',
          body: formDataWithImage,
        });


        const imageData = await imageResponse.json();
        // console.log('Image Response:', imageData);


        if (imageData.secure_url !== '') {
          imageUrl = imageData.secure_url;
          setUploadedImageUrl(imageData.secure_url); // Set uploaded image URL
        }
      }

      // Update other student information
      const updatedStudent = {
        ...editedStudent,
        profileUrl: imageUrl, // Assign the imageUrl here
      };


      const response = await axios.put(`student/${editedStudent.id}`, updatedStudent);


      if (response.status === 200) {
        const updatedStudents = students.map((student) =>
          student.id === editedStudent.id ? updatedStudent : student
        );
        setStudents(updatedStudents);
        closeEditModal();
        toast.success('Student updated successfully');
      } else {
        console.error('Failed to update student');
      }
    } catch (error) {
      console.error('Error updating student:', error);
    }
  };



  const handleBulkDownload = () => {
    const activeStudents = filteredStudents.filter(student => student.status === 'active');

    const fieldsToExclude = ['approve', 'password', 'batchName', 'profilePicture', 'id', 'registrationAdvanceId','fullname'];

    const cleanedStudents = activeStudents.map(student => {
      const cleaned = { ...student };
      fieldsToExclude.forEach(field => delete cleaned[field]);
      return cleaned;
    });

    // Convert headers to uppercase
    const transformedStudents = cleanedStudents.map(student => {
      const newStudent = {};
      Object.entries(student).forEach(([key, value]) => {
        newStudent[key.toUpperCase()] = value;
      });
      return newStudent;
    });

    const worksheet = XLSX.utils.json_to_sheet(transformedStudents);

    // Style the headers (bold, uppercase, font size)
    const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        font: {
          bold: true,
          sz: 14,
          color: { rgb: '000000' },
        },
      };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Active Students');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true,
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'active_students.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  const invoiceData = {
    companyName: 'JURONG ACADEMY',
    companyAddress: '134 Jurong Gateway Road,#03-307L (Head Office),Singapore 600134',
    companyPhone: '(65) 6635 5724',
    companyEmail: 'ask@ja.edu.sg',
    companyWebsite: 'https://ja.edu.sg',
  };

  const handleDownloadReceipt = (courseFeeDetails) => {
    const doc = new jsPDF('p', 'mm', 'a4');

    // Set font styles
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(16);

    // Add company information at the top of the PDF
    doc.text(`Company Name: ${invoiceData.companyName}`, 10, 10);
    doc.text(`Company Address: ${invoiceData.companyAddress}`, 10, 20);
    doc.text(`Company Phone: ${invoiceData.companyPhone}`, 10, 30);
    doc.text(`Company Email: ${invoiceData.companyEmail}`, 10, 40);
    doc.text(`Company Website: ${invoiceData.companyWebsite}`, 10, 50);

    // Add title
    doc.text('Course Fee Details', 10, 70);

    // Define table columns
    const columns = ["Session ID", "Session Date", "Amount", "Payment Mode", "Remarks", "Payment Status"];

    // Define table rows
    const rows = courseFeeDetails.map(detail => [
      detail.sessionId,
      formatDateEnd(detail.sessionDate),
      detail.amount,
      detail.paymentMode,
      detail.remarks,
      detail.paymentStatus
    ]);

    // Add table
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 80, // Adjust startY to leave space for company information
    });

    // Save the PDF file with a specific name
    doc.save('course_fee_details.pdf');
  };


  const handleOpenModal = (type, id) => {
    setLetterType(type);
    setSessionId(id);
    setShowModal1(true); // Open the dialog when this function is called
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal1(false);
  };

  const formatDate1 = (dateStr) => {
    const date = new Date(dateStr);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-GB', options);
  };

  // const moduleDetailsMap = {};
  // dataProp.batch?.moduleDetails.forEach((module) => {
  //   moduleDetailsMap[module.id] = module.moduleName;
  // });

  // scheduleData.forEach((schedule, index) => {
  //   const startDate = formatDate1(schedule.startDate);
  //   const endDate = formatDate1(schedule.endDate);
  //   const moduleName = moduleDetailsMap[schedule.startModulus+1];
  //   const scheduleText = `${startDate} To ${endDate} -${moduleName}`;
  //   console.log(scheduleText)
  // });
  const moduleDetailsMap = {};
  dataProp.batch?.moduleDetails.forEach((module) => {
    moduleDetailsMap[module.id] = module.moduleName;
  });

  scheduleData.forEach((schedule, index) => {
    const startDate = formatDate1(schedule.startDate);
    const endDate = formatDate1(schedule.endDate);
    const moduleName = moduleDetailsMap[schedule.startModulus];
    const scheduleText = `${startDate} To ${endDate} -${moduleName}`;
    console.log(scheduleText)
  });


  const filteredStudentsByType = filteredStudents.filter(student => {
    if (filterType === '') {
      return true; // Return true for all if no filter applied
    } else {
      return student.type === filterType;
    }
  });


  // const handlePhoneChange = (value, country) => {
  //   if (!isReadOnly) {
  //     const phoneWithoutCountryCode = value.slice(country.dialCode.length);
  //     const validatedPhone = phoneWithoutCountryCode.replace(/[^0-9]/g, '').substring(0, 8);
  //     setEditedStudent({
  //       ...editedStudent,
  //       phone: `+${country.dialCode} ${validatedPhone}`,
  //     });
  //   }
  // };


  const markSheets = studentDetails?.markSheet;
  const certificate = studentDetails?.certificate;
  const institutionDetails = studentDetails?.institutionDetails || [];

  // Filter out any keys that contain "Progress" or "Status" and entries with empty URLs
  const filteredMarkSheets = markSheets
    ? Object.entries(markSheets).filter(([key, url]) =>
      !key.includes('Progress') &&
      !key.includes('Status') &&
      url
    )
    : [];

  const filteredCertificate = certificate
    ? Object.entries(certificate).filter(([key, url]) =>
      !key.includes('Progress') &&
      !key.includes('Status') &&
      url
    )
    : [];


  return (
    <div>
      <Box
        sx={{
          position: 'fixed', // Keeps it in place
          top: '100px', // Fixed distance from the bottom
          left: '20px', // Fixed distance from the right
          zIndex: 1000 // Ensures it's above other content
        }}
      >

      </Box>
      <div className="container" style={{ maxWidth: '1400px' }}>
        {loading ? (
          <Loader />
        ) : (
          <Paper sx={{ width: '100%', margin: '10px', overflow: 'hidden' }}>
            {/* <div className="row"> */}
            {/* <div className="col-md-6"> */}
            <div
              className="filter-container"
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                marginBottom: '20px',
              }}
            >
              <input
                type="text"
                placeholder="Search by Name"
                value={searchQuery}
                onChange={handleSearch}
                className="form-control"
                style={{
                  flex: '1 1 200px',
                  minWidth: '150px',
                }}
              />

              <select
                value={filterGender}
                onChange={(e) => setFilterGender(e.target.value)}
                style={{
                  flex: '1 1 150px',
                  minWidth: '120px',
                  padding: '8px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '16px',
                }}
              >
                <option value="">Filter by Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>

              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                style={{
                  flex: '1 1 150px',
                  minWidth: '120px',
                  padding: '8px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '16px',
                }}
              >
                <option value="">Filter by Type</option>
                <option value="diploma">Diploma</option>
                <option value="advance_diploma">Advance Diploma</option>
              </select>

              <Button
                variant="contained"
                size="medium"
                onClick={handleBulkDownload}
                style={{
                  flex: '1 1 150px',
                  minWidth: '130px',
                  borderRadius: '8px',
                  backgroundColor: buttonBackgroundColor,
                }}
              >
                Bulk Download
              </Button>
            </div>

            {/* </div> */}
            {/* </div> */}
            <TableContainer
              sx={{
                overflowX: 'auto',
                maxWidth: '100%',
                '@media (min-width: 768px)': { // Apply styles for screens smaller than 768px (mobile)
                  overflowX: 'unset', // Enable horizontal scroll
                },
              }}
            >
              <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <Table aria-label="sticky table">
                  <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align="left"
                          style={{ fontWeight: 'bold' }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredStudentsByType
                      // .slice((currentPage - 1) * studentsPerPage, currentPage * studentsPerPage)
                      .map((student, index) => (
                        <TableRow key={student.id}>
                          <TableCell style={{ whiteSpace: 'nowrap' }}>{index + 1}</TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap', maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <span
                              title={`${student.fullname} details`}
                              style={{ cursor: 'pointer', color: 'blue' }}
                              onClick={() => openDetailsModal(student, false)}
                            >
                              {student.fullname.toUpperCase()}
                            </span>
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {student.email}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }}>{student.phone}</TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }}>{student.gender}</TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <BsPencilFill style={{ marginRight: 10 }} onClick={() => openDetailsModal(student, true)} />
                              <DeleteRoundedIcon style={{ color: 'red', marginLeft: 10 }} onClick={() => handleDelete(student.id)} />
                            </div>
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              variant="contained"
                              onClick={() => handleOpenStatusModal(student)}
                              style={{
                                borderRadius: '5px',
                                textTransform: 'none',
                                padding: '8px 20px',
                                backgroundColor: '#2F58A0',
                                color: 'white',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              Update Status
                            </Button>
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }}>
                            <Button variant="contained" onClick={() => handleViewStudent(student)} style={{ backgroundColor: buttonBackgroundColor }}>
                              View
                            </Button>
                          </TableCell>

                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
            </TableContainer>

            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Update Student Status</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="studentName">
                    <Form.Label>Student Name</Form.Label>
                    <Form.Control type="text" label="Full Name*"
                      name="fullname"
                      required
                      value={editedStudent ? editedStudent.fullname : ''}
                      placeholder="Enter student name" />
                  </Form.Group>

                  {/* <Form.Group controlId="studentId">
                    <Form.Label>Student ID</Form.Label>
                    <Form.Control type="text"
                      label="studentId*"
                      name="studentId"
                      value={editedStudent ? editedStudent.studentId : ''}
                      placeholder="Enter student ID" />
                  </Form.Group> */}



                  <Form.Group controlId="remarks">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control as="textarea" rows={3} placeholder="Enter remarks" />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="contained" color="error" onClick={handleClose} >
                  Close
                </Button>
                <Button variant="contained" onClick={handleClose} className="ml-2">
                  Update
                </Button>
              </Modal.Footer>
            </Modal>
            {/* <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={filteredStudents.length}
              rowsPerPage={studentsPerPage}
              page={currentPage - 1}
              labelDisplayedRows={({ from, to }) => `${from}-${to} Page No ${currentPage}`}
              onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
              onRowsPerPageChange={(event) => {
                setCurrentPage(1);
                setStudentsPerPage(event.target.value);
              }}
            /> */}
          </Paper>
        )}
      </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>Student Details</Modal.Title>
          {/* <Button onClick={handleDownloadPDF} variant="contained" color="primary">Download PDF</Button> */}
        </Modal.Header>
        <Modal.Body>
          <div id="modalContent">
            {studentDetails && (
              <>
                <Paper style={{ padding: 20, border: '1px solid #ccc' }}>

                  <Grid container spacing={3}>
                    {/* Personal Details */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Name:</strong> {studentDetails.name || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>{studentDetails?.proofType === 'NRIC' ? 'NRIC :' : 'FIN :'}</strong> {studentDetails.student?.nric || '-'}</Typography>
                    </Grid>


                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Surname:</strong> {studentDetails.student?.name || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Phone No:</strong> {studentDetails.handPhone || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Date of Birth:</strong> {studentDetails.dob || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Gender:</strong> {studentDetails.gender || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Country of Birth:</strong> {studentDetails.countryBirth || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Nationality:</strong> {studentDetails.nationality || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Passport No:</strong> {studentDetails.passportNo || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Email:</strong> {studentDetails.email || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Type:</strong> {studentDetails?.type || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Course:</strong> {studentDetails?.batch.course.replace(/\(\d+\)$/, '').trim() || '-'}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Intake:</strong> {studentDetails?.intake || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Country of Birth:</strong> {studentDetails?.countryBirth || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Know About Program:</strong> {studentDetails?.knowAboutProgram || '-'}</Typography>
                    </Grid>

                    {(studentDetails?.knowAboutProgram === 'referal' || studentDetails?.knowAboutProgram === 'other') && (
                      <Grid item xs={12} sm={6}>
                        {studentDetails?.knowAboutProgram === 'referal' ? (
                          <Typography variant="body1">
                            <strong>referal:</strong> {studentDetails?.referalfriend || '-'}
                          </Typography>
                        ) : (
                          <Typography variant="body1">
                            <strong>Others:</strong> {studentDetails?.otherDetails || '-'}
                          </Typography>
                        )}
                      </Grid>
                    )}
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Application Signature:</strong> {studentDetails?.applicationSignature || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Date:</strong> {formatDate(studentDetails?.date) || '-'}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Non-Singaporean:</strong> {studentDetails?.nonSingaporean || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Company:</strong> {studentDetails?.company || '-'}</Typography>
                    </Grid>





                    {/* Address Details */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Office):</strong> {studentDetails?.addressOffice || '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Home):</strong> {studentDetails?.addressHome || '-'}
                      </Typography>
                    </Grid>




                    {/* Emergency Contact */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} /> <strong>Emergency Contact: </strong>{studentDetails?.emergencyPhone || '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Emergency Contact Name:</strong> {studentDetails?.emergencyName || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Relation:</strong> {studentDetails?.emergencyRelation || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Office): </strong>{studentDetails?.phoneOffice || '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Home): </strong>{studentDetails?.phoneHome || '-'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>

                <Grid item xs={10} md={6}>
                  <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                    <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }}>Course Schedule</Typography>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>Start Date</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>End Date</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Module</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {scheduleData.map((schedule, index) => {
                            const startDate = formatDate1(schedule.startDate);
                            const endDate = formatDate1(schedule.endDate);
                            const moduleName = moduleDetailsMap[schedule.startModulus];
                            // const modulenum =moduleDetailsMap[schedule.]

                            return (
                              <TableRow key={index}>
                                <TableCell>{startDate}</TableCell>
                                <TableCell>{endDate}</TableCell>
                                <TableCell>{moduleName}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      <Grid item xs={6}  >
                        <Paper elevation={3} style={{ padding: '20px', height: '100%' }}>
                          <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }} >Institution Details</Typography>
                          {studentDetails?.institutionDetails && studentDetails?.institutionDetails.length > 0 ? (
                            <TableContainer>
                              <Table style={{ borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                                <TableHead>
                                  <TableRow >
                                    <TableCell style={{ fontWeight: 'bold' }}>Institution</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Year</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Full Time/Part Time</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Qualifications Achieved</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {studentDetails.institutionDetails.map((detail, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{detail.institution}</TableCell>
                                      <TableCell>{detail.year}</TableCell>
                                      <TableCell>{detail.fullTimeOrPartTime}</TableCell>
                                      <TableCell>{detail.qualificationsAchieved}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>

                              </Table>
                              <br />
                              <Table style={{ maxWidth: "100%", marginLeft: "4px" }}>
                                <TableHead>
                                  <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }} >Document Details</Typography>
                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }} >Document Name</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }} >View</TableCell>
                                    {/* <TableCell>Verify</TableCell> */}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {studentDetails && studentDetails.workPermitSpass && (
                                    <TableRow key="workPermitSpass">
                                      <TableCell>NRIC/WorkPermit/S-Pass Front</TableCell>
                                      <TableCell>
                                        <Box display="flex" gap={2}>
                                          <Button variant="contained"
                                            color="primary" style={{ marginRight: '4px' }} onClick={() => renderDoc(studentDetails.workPermitSpass)}>
                                            View
                                          </Button>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={async () => {
                                              try {
                                                const response = await fetch(studentDetails.workPermitSpass);
                                                if (!response.ok) throw new Error('Download failed');
                                                const url = URL.createObjectURL(await response.blob());
                                                const link = Object.assign(document.createElement('a'), { href: url, download: 'workPermitSpassDocument' });
                                                link.click();
                                                URL.revokeObjectURL(url);
                                              } catch (error) {
                                                console.error('Download failed:', error);
                                              }
                                            }}
                                          >
                                            Download
                                          </Button>
                                        </Box>

                                      </TableCell>
                                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('workPermitSpass')}>Verify</Button>
                        </TableCell> */}
                                    </TableRow>
                                  )}
                                  {studentDetails && studentDetails.workPermitOne && (
                                    <TableRow key="workPermitOne">
                                      <TableCell >NRIC/WorkPermit/S-Pass Back</TableCell>
                                      <TableCell>
                                        <Box display="flex" gap={2}>
                                          <Button variant="contained"
                                            color="primary" onClick={() => renderDoc(studentDetails.workPermitOne)}>
                                            View
                                          </Button>

                                          <Button variant="contained"
                                            color="primary"
                                            onClick={async () => {
                                              try {
                                                const response = await fetch(studentDetails.workPermitOne);
                                                if (!response.ok) throw new Error('Download failed');
                                                const url = URL.createObjectURL(await response.blob());
                                                const link = Object.assign(document.createElement('a'), { href: url, download: 'workPermitOne' });
                                                link.click();
                                                URL.revokeObjectURL(url);
                                              } catch (error) {
                                                console.error('Download failed:', error);
                                              }
                                            }}
                                          >
                                            Download
                                          </Button>
                                        </Box>
                                      </TableCell>
                                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('workPermitSpass')}>Verify</Button>
                        </TableCell> */}
                                    </TableRow>
                                  )}

                                  {studentDetails && studentDetails.passport && (
                                    <TableRow key="passport">
                                      <TableCell>Passport</TableCell>
                                      <TableCell>
                                        <Box display="flex" gap={2}>
                                          <Button variant="contained"
                                            color="primary" onClick={() => renderDoc(studentDetails.passport)}>
                                            View
                                          </Button>

                                          <Button variant="contained"
                                            color="primary"
                                            onClick={async () => {
                                              try {
                                                const response = await fetch(studentDetails.passport);
                                                if (!response.ok) throw new Error('Download failed');
                                                const url = URL.createObjectURL(await response.blob());
                                                const link = Object.assign(document.createElement('a'), { href: url, download: 'passport' });
                                                link.click();
                                                URL.revokeObjectURL(url);
                                              } catch (error) {
                                                console.error('Download failed:', error);
                                              }
                                            }}
                                          >
                                            Download
                                          </Button>
                                        </Box>
                                      </TableCell>
                                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('passport')}>Verify</Button>
                        </TableCell> */}
                                    </TableRow>
                                  )}
                                  {filteredMarkSheets.length > 0 ? (
                                    filteredMarkSheets.map(([level, url], index) => (
                                      <TableRow key={level}>
                                        <TableCell>
                                          Marksheet for {institutionDetails[index]?.institution || 'Unknown Institution'}
                                        </TableCell>
                                        <TableCell>
                                          <Box display="flex" gap={2}>
                                            <Button variant="contained"
                                              color="primary" onClick={() => renderDoc(url)}>
                                              View
                                            </Button>

                                            <Button variant="contained"
                                              color="primary"
                                              onClick={async () => {
                                                try {
                                                  const response = await fetch(url);
                                                  if (!response.ok) throw new Error('Download failed');
                                                  const blob = await response.blob();
                                                  const downloadUrl = URL.createObjectURL(blob);
                                                  const link = Object.assign(document.createElement('a'), { href: downloadUrl, download: `Marksheet` });
                                                  link.click();
                                                  URL.revokeObjectURL(downloadUrl);
                                                } catch (error) {
                                                  console.error('Download failed:', error);
                                                }
                                              }}
                                            >
                                              Download
                                            </Button>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  ) : (markSheets &&
                                    <TableRow>
                                      <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                                        <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No marksheets available
                                      </TableCell>
                                    </TableRow>
                                  )}

                                  {filteredCertificate.length > 0 ? (
                                    filteredCertificate.map(([level, url], index) => (
                                      <TableRow key={level}>
                                        <TableCell>
                                          Certificate for {institutionDetails[index]?.institution || 'Unknown Institution'}
                                        </TableCell>
                                        <TableCell>
                                          <Box display="flex" gap={2}>
                                            <Button variant="contained"
                                              color="primary" onClick={() => renderDoc(url)}>
                                              View
                                            </Button>

                                            <Button variant="contained"
                                              color="primary"
                                              onClick={async () => {
                                                try {
                                                  const response = await fetch(url);
                                                  if (!response.ok) throw new Error('Download failed');
                                                  const blob = await response.blob();
                                                  const downloadUrl = URL.createObjectURL(blob);
                                                  const link = Object.assign(document.createElement('a'), { href: downloadUrl, download: `Marksheet` });
                                                  link.click();
                                                  URL.revokeObjectURL(downloadUrl);
                                                } catch (error) {
                                                  console.error('Download failed:', error);
                                                }
                                              }}
                                            >
                                              Download
                                            </Button>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  ) : (certificate &&
                                    <TableRow>
                                      <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                                        <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No certificate available
                                      </TableCell>
                                    </TableRow>
                                  )}

                                  {studentDetails && studentDetails.profilePicture && (
                                    <TableRow key="profilePicture">
                                      <TableCell>Profile Picture</TableCell>
                                      <TableCell>
                                        <Box display="flex" gap={2}>
                                          <Button variant="contained"
                                            color="primary" onClick={() => renderDoc(studentDetails.profilePicture)}>
                                            View
                                          </Button>

                                          <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={async () => {
                                              try {
                                                const response = await fetch(studentDetails.profilePicture);
                                                if (!response.ok) throw new Error('Download failed');
                                                const url = URL.createObjectURL(await response.blob());
                                                const link = Object.assign(document.createElement('a'), { href: url, download: 'workPermitSpassDocument' });
                                                link.click();
                                                URL.revokeObjectURL(url);
                                              } catch (error) {
                                                console.error('Download failed:', error);
                                              }
                                            }}
                                          >
                                            Download
                                          </Button>
                                        </Box>
                                      </TableCell>
                                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('profilePicture')}>Verify</Button>
                        </TableCell> */}
                                    </TableRow>
                                  )}

                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            <Typography>No institution details available</Typography>
                          )}
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>



                          <div >
                            {studentInfo && (
                              <div>
                                {/* <Typography variant="h6" component="div" gutterBottom>
                  Student Details
                </Typography> */}
                                {/* <div>ID: {studentInfo.id}</div>
                <div>Name: {studentInfo.name}</div>
                <div>Email: {studentInfo.email}</div>
                <div>Email: {studentInfo.sureName}</div>
                <div>Email: {studentInfo.addressHome}</div>
                <div>Email: {studentInfo.date}</div>
                <div>Email: {studentInfo.email}</div>
                <div>Email: {studentInfo.registrationFee}</div>
                <div>Email: {studentInfo.courseFee}</div>
                <div>Email: {studentInfo.totalPaidAmount}</div>
                <div>Email: {studentInfo.paymentStatus}</div>
                <div>Email: {studentInfo.registrationFeeRemaining}</div>

                <div>Email: {studentInfo.passportNo}</div>
                <div>Email: {studentInfo.course}</div>

                <div>Email: {studentInfo.nric}</div>

                <div>Email: {studentInfo.intakeId}</div>
                <div>Email: {studentInfo.approver}</div>
                <div>Email: {studentInfo.emailSent}</div>
                <div>Email: {studentInfo.courseFeeRemaining}</div> */}



                                {/* Add more student details here */}
                              </div>
                            )}

                            {data && (
                              <div>
                                <Typography style={{ fontWeight: 'bolder' }} variant="h6" component="div" gutterBottom>
                                  Course Fee Details
                                </Typography>
                                <TableContainer component={Paper}>
                                  <Table aria-label="course fee details table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }} >Installment Count</TableCell>
                                        {/* <TableCell>Session ID</TableCell> */}
                                        <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Discount</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Payment Mode</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Action</TableCell>

                                        {/* <TableCell>Fee Type</TableCell> */}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {data.courseFeeDetails.length === 0 ? (
                                        <TableRow>
                                          <TableCell colSpan={8} style={{ textAlign: 'center' }}>
                                            No data available
                                          </TableCell>
                                        </TableRow>
                                      ) : (
                                        data.courseFeeDetails.map((feeDetail, index) => (
                                          <TableRow key={index}>
                                            <TableCell>{Array.isArray(feeDetail.installmentCounts) ? feeDetail.installmentCounts.join(',') : feeDetail.installmentCounts || '-'}</TableCell>
                                            {/* <TableCell>{feeDetail.sessionId}</TableCell> */}
                                            <TableCell>{feeDetail.sessionDate ? formatDateEnd(feeDetail.sessionDate) : '-'}</TableCell>
                                            <TableCell>{feeDetail.amount || '-'}</TableCell>
                                            <TableCell>{feeDetail.discountAmount || '-'}</TableCell>
                                            <TableCell>{feeDetail.paymentMode || '-'}</TableCell>
                                            <TableCell>{feeDetail.remarks || '-'}</TableCell>
                                            <TableCell>{feeDetail.status || '-'}</TableCell>
                                            <TableCell>
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<DownloadIcon />}
                                                onClick={() => handlePdfEdit1(feeDetail, data.type)} // Pass installment data here

                                              >
                                                View Receipt
                                              </Button>
                                            </TableCell>

                                            {/* <TableCell>{feeDetail.feeType}</TableCell> */}
                                          </TableRow>
                                        ))
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>

                                <Typography variant="h6" component="div" gutterBottom style={{ marginTop: '20px', fontWeight: 'bolder' }}>
                                  Registration Fee Details
                                </Typography>
                                <TableContainer component={Paper}>
                                  <Table aria-label="installments paid table">
                                    <TableHead>
                                      <TableRow>
                                        {/* <TableCell>Session ID</TableCell> */}
                                        {/* <TableCell>Installment Count</TableCell> */}
                                        <TableCell sx={{ fontWeight: 'bold' }} > Date</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} >Amount</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} >Discount</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} >Payment Mode</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} >Remarks</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} >Status</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} >Action</TableCell>
                                        {/* <TableCell>Fee Type</TableCell> */}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {data.installmentsPaid.length === 0 ? (
                                        <TableRow>
                                          <TableCell colSpan={7} style={{ textAlign: 'center' }}>
                                            No data available
                                          </TableCell>
                                        </TableRow>
                                      ) : (
                                        data.installmentsPaid.map((installment, index) => (
                                          <TableRow key={index}>
                                            {/* <TableCell>{installment.sessionId}</TableCell> */}
                                            {/* <TableCell>{installment.installmentCount}</TableCell> */}
                                            <TableCell>{installment.sessionDate ? formatDateEnd(installment.sessionDate) : '-'}</TableCell>
                                            <TableCell>{installment.amount || '-'}</TableCell>
                                            {/* <TableCell>{installment.discountAmount}</TableCell> */}
                                            {/* <TableCell>{data.amount1}</TableCell> */}
                                            {/* <TableCell>
                                            {data.amount1 !== 0 ? data.amount1 : installment.discountAmount}
                                          </TableCell> */}
                                            <TableCell>
                                              {index === 0
                                                ? (data.amount1 !== 0 ? data.amount1 : installment.discountAmount)
                                                : installment.discountAmount || '-'}
                                            </TableCell>
                                            <TableCell>{installment.paymentMode || '-'}</TableCell>
                                            <TableCell>{installment.remarks || '-'}</TableCell>
                                            <TableCell>{installment.status || '-'}</TableCell>
                                            <TableCell>
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<DownloadIcon />}
                                                onClick={() => handlePdfEdit(installment, index)} // Pass installment data here

                                              >
                                                View Receipt
                                              </Button>

                                            </TableCell>

                                            {/* <TableCell>{installment.feeType}</TableCell> */}
                                          </TableRow>
                                        )))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            )}
                          </div>

                          <div style={{ marginTop: '20px' }}>
                            <Stack
                              spacing={2}
                              direction={{ xs: 'column', sm: 'row' }}
                              alignItems="flex-start"
                              flexWrap="wrap"
                            >
                              <App ref={childRef} dataProp={dataForprop} />
                              <Button variant="contained" color="primary" onClick={handleContractletter}>
                                Student Contract
                              </Button>

                              <AdmissionOffer ref={admissionOfferRef} dataProp={dataForprop} />
                              <Button variant="contained" color="primary" onClick={handleOfferletter}>
                                Offer Letter
                              </Button>

                              <ApplicationForm
                                ref={applicationFormRef}
                                dataProp={dataForprop}
                                studentInfo={studentInfo}
                              />
                              <Button variant="contained" color="primary" onClick={handleApplicationForm}>
                                Application Form
                              </Button>
                            </Stack>
                          </div>

                        </Paper>
                      </Grid>

                    </TableContainer>
                  </Paper>
                </Grid>

              </>
            )}
          </div>


          <Dialog open={showModal1} onClose={handleCloseModal} fullScreen>
            <DialogTitle>
              {letterType === 'ContractLetter' ? 'Contract Letter' : (letterType === 'OfferLetter' ? 'Offer Letter' : 'Application Form')}
              <Button
                onClick={handleCloseModal}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '8px',
                  minWidth: 'unset',
                  padding: '8px', // Increase the padding for larger size
                  fontSize: '1.5rem', // Increase the font size for larger size
                }}
              >      X
              </Button>
            </DialogTitle>
            <DialogContent>
              {letterType === 'ContractLetter' && <ContractLetter sessionId={sessionId} />}
              {letterType === 'OfferLetter' && <OfferLetter sessionId={sessionId} />}
              {letterType === 'ApplicationForm' && <ApplicationForm sessionId={sessionId} />}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseModal} color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>


        </Modal.Body>
      </Modal>



      <Dialog open={isEditModalOpen}
        onClose={closeEditModal}

        maxWidth="md"  >
        <DialogTitle>
          {isReadOnly ? 'Student Details' : 'Edit Student (Jurong Academy)'}
        </DialogTitle>
        <DialogContent>
          <Editstudent from={false} studentId={editedStudent.registrationAdvanceId} />

        </DialogContent>
        <DialogActions>

          <Button onClick={closeEditModal} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
      <DeleteConfirmationModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleConfirm={handleConfirmDelete}
      />
      <Modal show={showStatusModal} onHide={handleCloseStatusModal}>
        <Modal.Header closeButton>
          <Modal.Title>Update Student Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="studentName">
              <Form.Label>Student Name</Form.Label>
              <Form.Control
                type="text"
                value={editedStudent ? editedStudent.fullname : ''}
                readOnly
              />

            </Form.Group>



            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="select"
                value={status}
                style={{
                  appearance: 'auto', // ensures native dropdown styling
                  WebkitAppearance: 'auto',
                  MozAppearance: 'auto',
                }}
                onChange={(e) => {
                  //  console.log('Selected value:', e.target.value);
                  setStatus(e.target.value);
                  if (e.target.value === '') {
                    toast.error('Please select a valid option.');
                  }
                }}
              >
                <option value="">Select status</option>
                <option value="Withdraw">Withdraw</option>
                <option value="Deferred">Deferred</option>
                <option value="Pending">Pending</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="remark">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                type="text"
                // value={remark}
                onChange={(e) => {
                  //  console.log('Selected value:', e.target.value);
                  setRemark(e.target.value);
                  // if (e.target.value === '') {
                  //   toast.error('Please select a valid option.');
                  // }
                }}
              />

            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" color="error" style={{
            // backgroundColor: '#2F58A0',
            // color: '#fff',
            borderRadius: '10%',
            padding: '10px 15px',
            marginLeft: '10px',
          }}
            onClick={handleCloseStatusModal}>
            Close
          </Button>
          <Button variant="primary" style={{
            backgroundColor: '#2F58A0',
            color: '#fff',
            borderRadius: '10%',
            padding: '10px 15px',
            marginLeft: '10px',
          }}
            onClick={handleStatusUpdate}>
            Update
          </Button>





        </Modal.Footer>
      </Modal>
      <Dialog open={open} onClose={() => setOpen(false)} fullScreen>
        <DialogTitle>View Receipt</DialogTitle>
        <DialogContent>
          {pdfUrl && (
            <iframe src={pdfUrl} width="100%" height="100%" style={{ minHeight: '90vh' }} title="PDF Preview"></iframe>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant='contained'  color="error" onClick={() => handleClosePdfDialog()} >Close</Button>
          {pdfUrl && (
            <Button color="primary" variant="contained" onClick={() => handleDownload()}>
              Download
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};


const New = () => {
  const [tabValue, setTabValue] = useState(0);


  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleTabChange = (newValue) => {
    setTabValue(newValue);
  };

  const theme = useTheme();
  const isLaptop = useMediaQuery('(min-width:600px) and (max-width:1400px)'); console.log('isLaptop', isLaptop)
  // console.log('isLaptop',isLaptop)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const usertype = localStorage.getItem("usertype")
  return (
    <div>
      <div>
        {usertype === '3' || usertype === '4' ? (
          <Header />
        ) : usertype === '6' ? (
          <FinHeader />
        ) : (

          null
        )}
      </div>
      <br />
      <div className="d-flex justify-content-center"
        style={{
          marginTop: isMobile ? '-30px' : isLaptop ? '-20px' : '-70px',
        }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="Students-tabs"
          variant="fullWidth"
          sx={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            "& button": {
              borderRadius: 10,
              color: "#555",
              margin: 'auto',
              display: 'block'
            },
            "& button:hover": {
              backgroundColor: "#eee",
            },
            "& button:active": {
              backgroundColor: "#ddd",
            },
            "& button.Mui-selected": {
              backgroundColor: "#007bff",
              color: "#fff",
            },
            "& .MuiTabs-indicator": {
              display: 'none', // Remove the underline
            },
            ...(isMobile && {
              flexDirection: 'column', // Stack tabs vertically
              "& button": {
                width: '100%', // Set tabs to full width on mobile
              },
            }),
          }}
        >
          <Tab
            label="All Students"
            sx={{
              minWidth: { xs: '50%', sm: '320px', md: '480px', lg: '640px' }
            }}
          />
          <Tab
            label="New Student"
            sx={{
              minWidth: { xs: '50%', sm: '320px', md: '480px', lg: '640px' }
            }}
          />
        </Tabs>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        {tabValue === 0 && <Screen />}
        {tabValue === 1 && <Newstudent />}
        {/* {tabValue === 1 && <registration />} */}

      </div>
    </div>
  );

};

export default New;


